<template>
  <layout-main-inner title="电子名片">
    <div slot="action">
      <el-button
        type="primary"
        @click="additem">
        新增电子名片
      </el-button>
      <el-dropdown>
        <el-button
          type="info"
          style="margin-left: 10px;">
          更多<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="downloadtmp">下载模板</el-dropdown-item>
          <el-dropdown-item @click.native="uploadtmp">批量上传</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <layout-card-wrap hasSlot>
      <template slot="form">
        <el-input
          v-model="config.name"
          clearable
          placeholder="请输入姓名"
          @clear="handleCurrentChange(1)"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"
          ></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="姓名"
          min-width="100"
          prop="name"> </el-table-column>
        <el-table-column
          label="手机号"
          width="110"
          prop="mobilePhone"> </el-table-column>
        <el-table-column
          label="微信手机号"
          width="110"
          prop="wxMobilePhone">
        </el-table-column>
        <el-table-column
          label="固定电话"
          width="110"
          prop="phone"> </el-table-column>
        <el-table-column
          label="邮箱"
          min-width="120"
          prop="email"> </el-table-column>
        <el-table-column
          label="部门"
          min-width="160"
          prop="department"></el-table-column>
        <el-table-column
          label="职位"
          min-width="160">
          <template slot-scope="{ row }">
            <div>{{ row.position }}</div>
            <div>{{ row.position2 }}</div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="150">
          <template slot-scope="{ row }">
            <el-button
              type="info"
              @click="updateitem(row)">
              编辑
            </el-button>
            <el-button
              type="danger"
              @click="deleteitem(row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </layout-card-wrap>
    <edit-address-book-modal
      ref="category"
      :callback="
        () => {
          getlist();
        }
      "
    />
    <el-upload
      ref="elUpload"
      action=""
      :limit="1"
      style="display: none;"
      accept=".xls,.xlsx"
      :show-file-list="false"
      :http-request="handleHttpRequest"
    >
      <i ref="upload"></i>
    </el-upload>
  </layout-main-inner>
</template>
<script>
import { mapState } from 'vuex'
import EditAddressBookModal from './edit-address-book-modal.vue'

export default {
  name: 'CategorysIndex',
  components: { EditAddressBookModal },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: {
        pageNum: 1,
        pageSize: 10,
        name: ''
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.account.userInfo
    })
  },
  mounted() {
    this.getlist()
  },
  methods: {
    downloadtmp() {
      this.loading = true
      this.$store.dispatch('account/downloadnamecardtemplate', {
        payload: {},
        success: () => {
          this.loading = false
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    handleHttpRequest(file) {
      const formData = new FormData()
      formData.append('file', file.file)
      this.loading = true
      this.$store.dispatch('account/uploadnamecard', {
        payload: formData,
        success: () => {
          this.loading = false
          this.$message.success('上传成功')
          this.$refs.elUpload.clearFiles()
          this.getlist()
        },
        fail: () => {
          this.$refs.elUpload.clearFiles()
          this.loading = false
        }
      })
    },
    uploadtmp() {
      this.$refs.upload.click()
    },
    updateitem(row) {
      this.$refs.category.update(row)
    },
    additem(row) {
      this.$refs.category.add(row)
    },
    deleteitem(row) {
      console.log(row)
      this.$confirm('您确定删除该名片?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('account/deletenamecard', {
          payload: {
            nameCardId: row.nameCardId
          },
          success: () => {
            this.loading = false
            this.getlist()
          },
          fail: () => {
            this.loading = false
          }
        })
      })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.getlist()
    },
    getlist() {
      this.loading = true
      this.$store.dispatch('account/getnamecards', {
        payload: this.config,
        success: (res) => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
